<template>
  <label class="map-buttons__btn" :class="[iconclass, {'map-buttons__btn--active': state}]">
    <input type="radio" :value="value" @change="onChange" :checked="state"> {{ label }}
  </label>
</template>
<script>
export default {
  name: 'MapButton',
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    value: {
      default: '',
    },
    label: {
      default: '',
    },
    iconclass: {
      default: '',
    },
    modelValue: {
      default: undefined,
    },
    checked: Boolean,
    // model: {}
  },
  computed: {
    state() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    }
  },
  methods: {
    onChange() {
      this.toggle();
    },
    toggle() {
      this.$emit('input', this.state ? '' : this.value);
    }
  },
  watch: {
    checked(newValue) {
      if (newValue !== this.state) {
        this.toggle();
      }
    }
  },
  mounted() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  }
}
</script>

<style lang="scss">

  @import './../../../../../_2017/dk/www/html/css/scss/breakpoints';

  .map-buttons__btn{
    display: inline-block;

    &--active{
      background: #e9e9e9;
    }
    &:before{
      content: "";
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background-repeat: no-repeat;
      background-size: contain;
      margin-right: 5px;
    }
    &.edu:before{
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiI+PHBhdGggZmlsbD0iIzgwODI4NSIgZD0iTTE4LjUzIDEyLjc3VjguODRsMS43My0uNzMtOS41NS00LjA2LTkuNTUgNC4wNiA5LjU1IDQuMDUgNy4yNC0zLjA3djMuNjhhMS4xNiAxLjE2IDAgMCAwIC4yOSAyLjI4IDEuMTYgMS4xNiAwIDAgMCAuMjktMi4yOHptLTIuMzIgMi4zdi0zLjc4bC01LjUgMi4zMi01LjUtMi4zMnYzLjc3czEuMjMgMi41NyA1LjUgMi4yOWM0LjM0IDAgNS41LTIuMjkgNS41LTIuMjl6Ii8+PC9zdmc+);
    }
    &.medical:before{
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIvPjxwYXRoIGZpbGw9IiM4MDgyODUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTkgNWExIDEgMCAwIDEgLjk5LTFoNC4wMkExIDEgMCAwIDEgMTUgNXY0aDRhMSAxIDAgMCAxIDEgLjk5djQuMDJhMSAxIDAgMCAxLTEgLjk5aC00djRhMSAxIDAgMCAxLS45OSAxSDkuOTlBMSAxIDAgMCAxIDkgMTl2LTRINWExIDEgMCAwIDEtMS0uOTlWOS45OUExIDEgMCAwIDEgNSA5aDRWNXoiLz48L3N2Zz4=);
    }
    &.kinder:before{
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiI+PHBhdGggZmlsbD0iIzgwODI4NSIgZD0iTTcuNTMgNS43OWExLjc0IDEuNzQgMCAxIDAgMC0zLjQ4IDEuNzQgMS43NCAwIDAgMCAwIDMuNDh6bTIuMzEuNThINS4yMmwtLjMuMjUtMi42IDQuOTYgMS4xNS41OCAxLjc1LTMuNDh2MTAuNDNoMS43M1YxMy45SDguMXY1LjJoMS43M1Y4LjdsMi4zMiA0LjM0IDIuMzEtLjU4djYuNjZoMS4xNnYtNC4wNmguNTh2NC4wNmgxLjE2di02LjM3bDIuMzEgMS40NC41OC0uODZMMTcuMzcgMTFoLTIuOWwtMS43My42My0yLjYtNS0uMy0uMjZ6bTYuMDggNC4wNWExLjE2IDEuMTYgMCAxIDAgMC0yLjMxIDEuMTYgMS4xNiAwIDAgMCAwIDIuMzF6Ii8+PC9zdmc+);
    }
    &.sport:before{
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiI+PHBhdGggZmlsbD0iIzgwODI4NSIgZD0iTTYuOTUgOS44NGg4LjF2MS43NGgtOC4xVjkuODR6TTQuMDUgNS44aDIuMzJ2OS44NEg0LjA1VjUuOHptMTEuNTggMGgyLjMydjkuODRoLTIuMzJWNS44em0yLjkgMi4zMWgxLjczdjUuMjJoLTEuNzNWOC4xem0tMTYuOCAwaDEuNzV2NS4yMkgxLjc0VjguMXoiLz48L3N2Zz4=);
    }
    &.food:before{
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiI+PHBhdGggZmlsbD0iIzgwODI4NSIgZD0iTTE1LjA1IDE4LjUzYzAgLjI0LjMyLjU4LjU4LjU4aC41OGMuMjYgMCAuNTgtLjM0LjU4LS41OFYyLjkycy0xLjctLjUzLTIuNzQgMy4xNWMtLjIuODUtLjczIDIuNDQtLjczIDMuODJzLjQ1IDIuOTIuNDUgMi45Mi4yNSAxLjA4LjcgMS4wOGguNTh2NC42M3ptLTcuNTIuNThoLjU4Yy4yNiAwIC41Ny0uMzMuNTctLjU4VjExQzEwIDEwLjQxIDExIDguNTQgMTEgNi45NVYzLjQ3YzAtLjI1LS4yMy0uNTgtLjU4LS41OHMtLjU4LjM0LS41OC41OHYyLjljMCAxLjA0LS44NyAxLjctMS4xNiAxLjc0TDguNCAzLjQ3YzAtLjI0LS4zLS41OC0uNTgtLjU4LS4yNiAwLS41Ny4zMy0uNTcuNThsLS4zIDQuNjRBMS44NiAxLjg2IDAgMCAxIDUuOCA2LjM3di0yLjljMC0uMjQtLjI5LS41OC0uNTgtLjU4cy0uNTguMzMtLjU4LjU4djMuNDhjMCAxLjYyIDEgMy40OCAyLjMyIDQuMDV2Ny41M2MwIC4yNS4zLjU4LjU4LjU4eiIvPjwvc3ZnPg==);
    }
    &.shop:before{
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiI+PHBhdGggZmlsbD0iIzgwODI4NSIgZD0iTTIuOSAzLjQ3aDMuNzZMOC4xIDYuOTVoMTAuNDJWMTFsLTkuODQgMi4zMkw1LjIgNS4ySDIuOVYzLjQ3em00LjA1IDE0LjQ4YTEuNzQgMS43NCAwIDEgMCAwLTMuNDggMS43NCAxLjc0IDAgMCAwIDAgMy40OHptNy41MiAwYTEuNzQgMS43NCAwIDEgMCAwLTMuNDggMS43NCAxLjc0IDAgMSAwIDAgMy40OHoiLz48L3N2Zz4=);
    }
    &.cinema:before{
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiI+PHBhdGggZmlsbD0iIzgwODI4NSIgZD0iTTE0LjQ3IDExLjU4SDQuMDV2Ni45NWgxMC40MlYxNi4ybDUuMjEgMS43NHYtNS44bC01LjIgMS43NHYtMi4zMXptLTEuNzMtMS43NGEzLjQ3IDMuNDcgMCAxIDAgMC02Ljk1IDMuNDcgMy40NyAwIDAgMCAwIDYuOTV6bS03LjgyIDBhMi42IDIuNiAwIDEgMCAwLTUuMjEgMi42IDIuNiAwIDAgMCAwIDUuMjF6Ii8+PC9zdmc+);
    }
    input{
      appearance: none;
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MapButton.vue